
import { Component, Vue, Prop } from "vue-property-decorator";
import { commonModule, installationsModule, offersModule } from "@/store/modules/store-accessor";
import AssigneeCombo from "@/components/Combobox/AssigneeCombo.vue";
import { TimeUtil } from "@/helpers/TimeUtil";

@Component({
  components: { AssigneeCombo },
})
export default class EditOfferModal extends Vue {
  @Prop()
  payload!: OfferDto;

  dateMenu = false;

  payloadAssignee = null as Record<string, any> | null;

  offerModel = {
    id: this.payload.id,
    assignee_id: this.payload.assignee_id,
    valid_until: this.formatDate((this.payload.valid_until as any)),
    title: this.payload.title,
    notes: this.payload.notes,
    internal_notes: this.payload.internal_notes,
    installation_id: this.payload.installation_id,
  };

  updateAssignee(assignee: Record<string, any> | null) {
      this.offerModel.assignee_id = assignee;
  }

  isEditingOffer = false;

  clearDate() {
    this.offerModel.valid_until = "";
  }


  formatDate(date: Date): string {
    return TimeUtil.formatDateOnly(date);
  }

  async hideModal() {
    commonModule.hideModal();
  }

  async mounted() {
    if (this.payload.assignee_id || (this.payload.assignee_name ?? "").trim()) {
      this.payloadAssignee = { id: this.payload.assignee_id, name: this.payload.assignee_name };
    }
    commonModule.initSnackbar({});
  }

    titleRules = [
      (val: any) => !!val || this.$i18n.t("title_required"),
      (val: any) => val?.length <= 200 || this.$i18n.t("offerTitleLengthRule"),
    ]

    notesRules = [
      (val: any) => {
        if(val != null) return val.length <= 1000 || this.$i18n.t("notesLengthRule");
        else return true;
      },
    ]

    internalNotesRules = [
      (val: any) => {
        if(val != null) return val.length <= 1000 || this.$i18n.t("internalNotesLengthRule");
        else return true;
      },
    ]

    async doEditOffer() {
      if (!(this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        return;
      }

      this.isEditingOffer = true;

      try {
        await installationsModule.updateInstallationOffer(this.offerModel);
        this.hideModal();
      } finally {
        this.isEditingOffer = false;
      }
    }

}
